import '../modules/infiniteslidev2.min';
const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $partnersSlider = $sectionInstance.find( '.js-partners-slider' );

		if ( !$partnersSlider.length || $partnersSlider.data( 'style' ) ) {
			return;
		}

		$partnersSlider.infiniteslide( {
			'speed': 50,
			'direction': 'left',
			'pauseonhover': true,
			'responsive': true,
			'clone': 6
		} );
	} );
};

app.loadBlock( initBlock, 'partners', '.section-partners' );

if ( module.hot ) {
	module.hot.accept();
}
